module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/rib-c02c5ed4ca8ab0e45d998c8a85cc200c.png";